/** `Object.keys` with correct type for the keys */
export function keysOf<T extends Record<string, unknown>, K extends keyof T>(record: T): K[] {
  return Object.keys(record) as K[];
}
